import { render } from "./organizationModel.vue?vue&type=template&id=86f9052e&scoped=true"
import script from "./organizationModel.js?vue&type=script&lang=js"
export * from "./organizationModel.js?vue&type=script&lang=js"

import "./organizationModel.vue?vue&type=style&index=0&id=86f9052e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f9052e"]])

export default __exports__